/**
 * The restricted content cookie name, dependent on the current site.
 */
export default `${amScripts.global.sitePrefix}-restricted-content-access`;
